<script>
    import { onMount, onDestroy, createEventDispatcher } from 'svelte'
    import { Calendar } from '@fullcalendar/core'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import interactionPlugin, { Draggable } from '@fullcalendar/interaction'
    
    import { height as windowHeight } from '../../stores/bounds'

    export let events = []
    export let options = {}
    export let ref = null


    let container = null


    const dispatch = createEventDispatcher ();

    const datesChange = (info) => {
        // console.log ('info', info)
        dispatch ('period-change', info)
    }

    const eventsRenderer = (eventsList) => {
        if (ref) {
            ref.removeAllEvents ();
            ref.addEventSource (eventsList);
        }
    }

    onMount (() => {
        ref = new Calendar (container, {
            ...{
                locale: 'it',
                firstDay: 1,
                plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
                datesSet: datesChange,
                // initialView: 'timeGridWeek',
                events: [ ]
            },
            ...options
        });

        ref.render ();
    })

    onDestroy (() => {
        if (ref) {
            ref.destroy ();
            ref = null;
        }
    })


    $: {
        if (events)
            eventsRenderer (events);
    }
</script>

<style>
    :global(.fc-daygrid-body) {
        background-color: #f9fcff;
        --fc-border-color: #d5e1e6;
    }
    :global(.fc-theme-standard td, .fc-theme-standard th), 
    :global(.fc-theme-standard .fc-scrollgrid) {
        border: 1px solid #d5e1e6;
    }
    :global(.fc .fc-cell-shaded, .fc .fc-day-disabled) {
        background-color: #ecf3f7;
    }
</style>

<div bind:this={container} class="FullCalendar"> </div>